export default {
  // 查询用户列表
  getUserList: {
    url: '/userApi/getUserList',
    method: 'POST'
  },
  // 查询用户信息
  getUserInfo: {
    url: '/userApi/getUserInfo',
    method: 'GET'
  },
  // 查询所有用户列表
  getAllUserList: {
    url: '/userApi/getAllUserList',
    method: 'GET'
  }
}